import { FocusEvent, KeyboardEvent, ChangeEvent } from 'react';
import {
  StyledTextareaWrapper,
  StyledTextarea,
} from 'components/Kizen/Textarea/styles';
import Pill from 'components/Kizen/Pill';
import styled from '@emotion/styled';

interface StyledTextareaWrapperProps {
  error?: boolean;
  underline?: boolean;
  disabled?: boolean;
}

interface StyledPillProps {
  key: string;
  name: string;
  onRemove: (id: string) => void;
  hideRemoveIcon?: boolean;
}

interface StyledTextareaProps {
  value: string;
  placeholder?: string;
  id?: string;
  onChange: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  onFocus?: (e: FocusEvent<HTMLTextAreaElement>) => void;
  onBlur?: (e: FocusEvent<HTMLTextAreaElement>) => void;
  onKeyDown?: (e: KeyboardEvent<HTMLTextAreaElement>) => void;
  disabled?: boolean;
  rows?: number;
  resize?: string;
}

export const StyledInputAreaWithPillsWrapper = styled(
  StyledTextareaWrapper
)<StyledTextareaWrapperProps>`
  alignitems: 'center';
  flexwrap: 'wrap';
  max-height: 65px;
  overflow-y: auto;
`;

export const StyledPill = styled(Pill)<StyledPillProps>`
  margin: 5px;
`;

export const StyledTextareaWithPills = styled(
  StyledTextarea
)<StyledTextareaProps>`
  width: 100%;
`;
